export interface VehicleDto {
  id: number;
  type: VehicleType;
  registration: string;
  length: number;
  height: number;
  width: number;
  payload: number;
  status?: VehicleStatus;
  forwarderId?: number;
  forwarderName?: string;
  keeperId?: number;
  keeperName?: string;
  keeperPhonePrefix?: string;
  keeperPhone?: string;
  connectedId?: number;
  connectedName?: string;
  companyId: number;
  companyName: string;
  sharedId?: number;
  sharedName: string;
  hasKeeper: boolean;
  hasForwarder: boolean;
  isShared: boolean;
}

export interface CreateVehicleRequest {
  registration: string;
  length: number | null;
  height: number | null;
  width: number | null;
  payload: number | null;
  type: VehicleType;
}

export type CreateTruckRequest = Omit<CreateVehicleRequest, 'type'>;
export interface ShareVehicleRequest {
  email: string;
  vehicleId: number;
}

interface VehicleActionBase {
  vehicleId: number;
}

export interface VehicleAssign extends VehicleActionBase {
  driverId: number;
}

export interface VehicleEntrust extends VehicleActionBase {
  userId: number;
}

export interface VehicleConnect extends VehicleActionBase {
  toConnectId: number;
}

export enum VehicleStatus {
  Free = 'free',
  OnTheRoad = 'on_the_road',
}

export enum VehicleType {
  Truck = 'truck',
  Trailer = 'trailer',
}
